var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTimesIconinline = function SvgTimesIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#111E6C",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.704 29L30 1.704 28.296 0 1 27.296c-.555.554-.62 1.38-.148 1.852.47.47 1.298.406 1.852-.148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.296 29L0 1.704 1.704 0 29 27.296c.554.554.62 1.38.148 1.852-.47.47-1.298.406-1.852-.148z"
  }))));
};
export default SvgTimesIconinline;